import { render, staticRenderFns } from "./criteria-legends.vue?vue&type=template&id=0f096ab6&scoped=true"
import script from "./criteria-legends.vue?vue&type=script&lang=js"
export * from "./criteria-legends.vue?vue&type=script&lang=js"
import style0 from "./criteria-legends.vue?vue&type=style&index=0&id=0f096ab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f096ab6",
  null
  
)

export default component.exports